/**
 * Cart drawer shipping progress + hint text from /cart.js
 */
(function () {
  const root = document.querySelector('[data-pi-cart-extras]');
  if (!root) return;

  const threshold = Number(root.dataset.piShippingThreshold || 9900);
  const shipBlock = root.querySelector('[data-pi-shipping-block]');
  const labelEl = root.querySelector('[data-pi-shipping-label]');
  const fillEl = root.querySelector('[data-pi-shipping-fill]');
  const hintEl = root.querySelector('[data-pi-cart-hint]');
  const bar = root.querySelector('[data-pi-shipping-block] [role="progressbar"]');

  function money(cents) {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    return `$${(cents / 100).toFixed(2)}`;
  }

  function updateUI(cart) {
    const total = cart.total_price || 0;
    const empty = !cart.item_count;
    root.toggleAttribute('data-cart-empty', empty);

    if (empty) {
      if (shipBlock) shipBlock.hidden = true;
      if (hintEl) hintEl.hidden = true;
      return;
    }

    if (shipBlock && labelEl && fillEl && threshold > 0) {
      shipBlock.hidden = false;
      const remaining = Math.max(0, threshold - total);
      const pct = Math.min(100, Math.round((total / threshold) * 100));
      fillEl.style.width = `${pct}%`;
      if (bar) {
        bar.setAttribute('aria-valuenow', String(pct));
      }
      if (remaining <= 0) {
        labelEl.textContent = 'You unlocked free shipping!';
      } else {
        labelEl.textContent = `Add ${money(remaining)} more for free shipping`;
      }
    }

    if (hintEl && cart.item_count) {
      hintEl.hidden = false;
      hintEl.textContent = `${cart.item_count} item${cart.item_count === 1 ? '' : 's'} in your bag`;
    }
  }

  async function fetchCart() {
    try {
      const res = await fetch(`${window.routes?.cart_url || '/cart'}.js`);
      return await res.json();
    } catch {
      return null;
    }
  }

  document.addEventListener('pi:cart-updated', async () => {
    const cart = await fetchCart();
    if (cart) updateUI(cart);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', async () => {
      const cart = await fetchCart();
      if (cart) updateUI(cart);
    });
  } else {
    fetchCart().then(updateUI);
  }

  const applyBtn = root.querySelector('[data-pi-discount-apply]');
  if (applyBtn) {
    applyBtn.addEventListener('click', () => {
      const input = root.querySelector('.pi-cart-extras--gift input');
      if (input?.value) window.location.href = `/discount/${encodeURIComponent(input.value.trim())}`;
    });
  }
})();
